import { LoginValues } from '../infrastructure/StorageService';
import { StorageService } from '../infrastructure/StorageService';

/**
 * Application service for user credentials management
 */
export class UserCredentialsService {
  constructor(private storageService: StorageService) {}

  /**
   * Save user credentials (username only now)
   */
  saveUserCredentials(userName: string): void {
    this.storageService.saveUserCredentials(userName);
    // Always save username for user preferences
    this.saveUserName(userName);
  }

  /**
   * Save username
   */
  saveUserName(userName: string): void {
    this.storageService.saveUserName(userName);
  }

  /**
   * Clear saved credentials
   */
  clearSavedCredentials(): void {
    this.storageService.clearSavedCredentials();
  }

  /**
   * Get saved credentials
   */
  getSavedCredentials(): LoginValues {
    return this.storageService.getSavedCredentials();
  }
}
